import { type AddHookResponse, mutationAdd } from '../hooks'
import { useTantalimMutation } from '../mutation'
import { useVideoCache } from './cache'
import { toResponseError, type VideoUserInput, type VideoUserSuccess } from '@terros/common'

export function useVideoUser(): AddHookResponse<VideoUserInput, VideoUserSuccess> {
  const mutation = useTantalimMutation<VideoUserInput, VideoUserSuccess>({
    url: '/video/user',
  })
  const cache = useVideoCache()

  async function add(input: VideoUserInput): Promise<VideoUserSuccess> {
    try {
      const res = await mutation.mutateAsync(input)
      const { video, videoUser } = res
      cache.updateWithAction({ video, videoUser })
      return res
    } catch (error) {
      throw toResponseError(error)
    }
  }

  return mutationAdd(mutation, add)
}
